/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2025.
 */

import { skipToMainContentLinkSX } from '@/components/blocks/SkipToMainContent/styles/link';
import { useLocalization } from '@/data/Localization';
import { Button } from '@mui/material';
import { FC } from 'react';

export const SkipToMainContent: FC = () => {
	const nls = useLocalization('Common');
	return (
		<Button
			type="link"
			variant="contained"
			href="#main-content"
			aria-label={nls.SkipToMainContent.t()}
			sx={skipToMainContentLinkSX}
		>
			{nls.SkipToMainContent.t()}
		</Button>
	);
};
